/* eslint-disable */
let dataUser = JSON.parse(localStorage.getItem("userData"))
console.log('access en navi',dataUser)
let mod = {
  header: 'Modulos'
}
if (dataUser != null) {
  dataUser.data.access.unshift(mod)
}

export default dataUser != null ? dataUser.data.access: []
// export default [
//   {
//     header: 'Modulos',
//   },
//   {
//     id: 'home',
//     title: 'Inicio',
//     icon: 'HomeIcon',
//     route: 'home',
//   },
//   {
//     title: 'Locales',
//     icon: 'MapPinIcon',
//     children:[
//       {
//         title: 'Listar',
//         id: 'LocalesListar',
//         route: 'locals-list'
//       }
//     ]
//   },
//   {
//     title: 'Usuarios',
//     icon: 'UserIcon',
//     children: [
//       {
//         id: 'UsuariosListar',
//         title: 'Listar',
//         route: 'users-list',
//       },
//       // {
//       //   id: 'UsuariosAgregar',
//       //   title: 'Agregar',
//       //   route: { name: 'users-add' },
//       // },
//       {
//         id: 'RolesAsignacion',
//         title: 'Asignación',
//         route: { name: 'users-asignacion' },
//       },
//       {
//         id: 'UsuariosEditar',
//         title: 'Editar',
//         hide: true,
//         route: { name: 'users-edit' },
//       },
//     ],
//   },
//   {
//     title: 'Inventario',
//     icon: 'BoxIcon',
//     children: [
//       {
//         id: 'InventarioStock',
//         title: 'Stock',
//         route: { name: 'stock-list' },
//       },
//       {
//         id: 'InventarioEntrada',
//         title: 'Entrada',
//         route: { name: 'stock-entrada' },
//       },
//       {
//         id: 'InventarioSalida',
//         title: 'Salida',
//         route: { name: 'stock-salida' },
//       },
//     ],
//   },
//   {
//     title: 'Tipos',
//     icon: 'TagIcon',
//     children: [
//       {
//         id: 'TiposEntrada',
//         title: 'Tipos de Entrada',
//         route: { name: 'tipos-entrada' },
//       },
//       {
//         id: 'TiposSalida',
//         title: 'Tipos de Salida',
//         route: { name: 'tipos-salida' },
//       },
//     ],
//   },
//   {
//     title: 'Autopartes',
//     icon: 'TruckIcon',
//     children: [
//       {
//         id: 'Marcas',
//         title: 'Marcas',
//         route: { name: 'autopartes-marcas' },
//       },
//       {
//         id: 'ListarAutopartes',
//         title: 'Listar',
//         route: { name: 'autopartes-list' },
//       },
//     ],
//   },
//   {
//     title: 'Reportes',
//     icon: 'TrendingUpIcon',
//     children: [
//       {
//         id: 'ReporteLocales',
//         title: 'Por Local',
//         route: { name: 'reportes-locals' },
//       },
//       {
//         id: 'ReporteProductosTop',
//         title: 'Productos Top',
//         route: { name: 'reportes-top-products' },
//       },
//       {
//         id: 'ReporteProductos',
//         title: 'Por productos',
//         route: { name: 'reportes-products' },
//       },
//       {
//         id: 'ReporteVentas',
//         title: 'De Ventas',
//         route: { name: 'reportes-ventas' },
//       },
//     ],
//   },
// ]
